import { useState } from "react";
import { useReducedMotion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { clients } from "@/data/portfolio";

export default function Clients() {
  const [playing, setPlaying] = useState(true);
  const reducedMotion = useReducedMotion();
  const names = clients.map(name => <span key={name} className="client-pill serif">{name}<i className="client-pill__dot" aria-hidden /></span>);
  return <section id="clients" className="section clients" data-testid="clients-section">
    <header className="section__head section__head--center">
      <span className="overline">◆ Trusted by</span>
      <h2 className="section__title serif">Working with creators &amp;<br /><span className="italic">teams who&nbsp;ship.</span></h2>
    </header>
    {!reducedMotion && <button className="chip" aria-pressed={playing} onClick={() => setPlaying(value => !value)}>{playing ? "Pause client reel" : "Play client reel"}</button>}
    {playing && !reducedMotion ? <div className="clients__marquee"><Marquee gradient={false} speed={42}>{names}</Marquee></div> : <div className="clients-list">{names}</div>}
  </section>;
}
